interface SaveUserGrantsRequestPayload {
  catalog_permission: {
    view_type: 'user'
    data: Record<string, number[]>
  }
}

export const mapSaveUserGrantsPayload = (
  userId: number,
  secondaryCategoryIds: number[]
): SaveUserGrantsRequestPayload => ({
  catalog_permission: {
    view_type: 'user',
    data: {
      [userId]: secondaryCategoryIds,
    },
  },
})
